export default __webpack_public_path__ + "static/media/play_icon.6cffcb04.svg";